import script from "./CancelReg.vue?vue&type=script&setup=true&lang=js"
export * from "./CancelReg.vue?vue&type=script&setup=true&lang=js"

import "./CancelReg.vue?vue&type=style&index=0&id=95ae67fc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95ae67fc"]])

export default __exports__